import {
    GET_MY_ORDERS,
    GET_MY_ORDERS_GRID_COUNT
} from './types'
import api from '../../client/utils/clientApiHelper' 
import {all,takeEvery,put,call, takeLatest} from 'redux-saga/effects'
import * as CustomerMyOrderActions from './actions';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setIsMyOrdersGridCountsLoading, setIsMyOrdersGridLoading } from 'Store/Transfer/TransferGrid/TransferGridAction';
export const myordersState = (state:any) => state.CustomerMyOrder?.myOrderData;

function* getMyOrderHandler(req:any):any {
    yield put(setIsMyOrdersGridLoading(true))
    let payloadData : IPayload= {
        apiType : apiType.OrderManagement,
        endpoint : `orders/grid/requisition`,
        apiMethod : apiMethod.POST,
        payload : req?.emailId
    }
    try {
        const response = yield call(api.callOrderPost, API_URL.PostWebApp,payloadData );
        yield put(CustomerMyOrderActions.setMyOrder(response))
        yield put(setIsMyOrdersGridLoading(false))
    } catch (error) {
        yield put(CustomerMyOrderActions.setMyOrder([]))
        yield put(setIsMyOrdersGridLoading(false))
    }
}

function* getMyOrderGridCount(req:any):any {
    yield put(setIsMyOrdersGridCountsLoading(true))
    let payloadData : IPayload= {
        apiType : apiType.OrderManagement,
        endpoint : `orders/grid/requisition/count`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    try {
        const response = yield call(api.callOrderPost, API_URL.PostWebApp, payloadData);
        yield put(CustomerMyOrderActions.setMyOrderGridCount(response))
        yield put(setIsMyOrdersGridCountsLoading(false))
    } catch (error) {
        yield put(CustomerMyOrderActions.setMyOrderGridCount([]))
        yield put(setIsMyOrdersGridCountsLoading(false))
    }
}


function* watcherGetMyOrder() {
    yield takeLatest(GET_MY_ORDERS,getMyOrderHandler)
    yield takeEvery(GET_MY_ORDERS_GRID_COUNT,getMyOrderGridCount)
}

export default function* combinedSaga() {
    yield all([
        watcherGetMyOrder()
    ])
}